import * as React from 'react';
import { SVGProps } from 'react';

const SvgSpecialSituations = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.248.965a.75.75 0 0 1 .75.75v11.82h13.754a.75.75 0 0 1 0 1.5H1.248a.75.75 0 0 1-.75-.75V1.715a.75.75 0 0 1 .75-.75Z"
      fill="#174174"
    />
    <path
      d="M13.8 3.04c.284.01.495.236.473.504l-.368 4.362c-.022.267-.27.475-.553.464-.284-.011-.495-.237-.473-.505l.327-3.877-4.103-.161c-.283-.011-.495-.237-.472-.505.022-.268.27-.476.554-.464l4.616.181Zm.294.84-.423.355-.667-.714.422-.354.668.714Z"
      fill="#174174"
    />
    <rect
      x={3.021}
      y={11.762}
      width={12.945}
      height={1.281}
      rx={0.64}
      transform="rotate(-40 3.02 11.762)"
      fill="#174174"
    />
  </svg>
);

export default SvgSpecialSituations;
